<div class="container-loading" *ngIf="showLoading">
  <div class="wrapper">
    <div class="circle circle-1"></div>
    <div class="circle circle-2"></div>
    <div class="circle circle-3"></div>
    <div class="shadow"></div>
    <div class="shadow"></div>
    <div class="shadow"></div>
  </div>
  <p class="loading-text pt-2 pt-lg-4">{{message}}</p>
</div>

<div class="container-loaded" *ngIf="!showLoading">
  <p class="loaded-text-title mt-3 mt-md-0">
    Un mensaje para ti<mat-icon class="icon-title-message">favorite</mat-icon>
  </p>
  <p class="loaded-text-message">{{message}}</p>
</div>